import { FC, useState, ChangeEvent } from 'react';
import { useAppDispatch } from 'hooks/useStore';
// Models
import IAnswer from 'models/Answer';
import IOption from 'models/Option';
// Selectors
import { setQuestionAnswerPicked, setQuestionStart } from 'store/player/playerSlice';
// Component
import { Button } from 'components/Buttons';
import { Select } from 'components/Controls';
// i18next
import { useTranslation } from 'react-i18next';

type Props = {
  answers: IAnswer[];
  onSubmit: (answer:{ ref:string, title:string, correct?:boolean }) => void;
  disabled?:boolean;
};

const AnswerDropdown:FC<Props> = ({ answers, onSubmit, disabled = false }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const answersAsOptions: IOption[] = answers.map(answer => ({
    label: answer.title, value: answer.ref
  }))
  answersAsOptions.unshift({ value: '', label: t('labels.chooseAnswer'), disabled: true });

  const [ clicked, setClicked ] = useState<boolean>(false);
  const [answer, setAnswer] = useState<IOption['value']>('');

  const handleAnswer = (e: ChangeEvent<HTMLSelectElement>) => {
    setAnswer(e.target.value);
  }

  const handleSubmit = () => {
    if(clicked) return;
    const selectedAnswer = answers.find(a => a.ref === answer);
    if (selectedAnswer) {
      const { ref, title, correct } = selectedAnswer;
      dispatch(setQuestionStart(false));
      onSubmit({ ref, title, correct });
      dispatch(setQuestionAnswerPicked(true));
      setClicked(true);
    }
  }

  return (
    <div>
      <Select
        id="questions-answers-dropdown"
        name="questions-answers-dropdown"
        options={answersAsOptions}
        value={answer}
        onChange={handleAnswer}
        disabled={disabled || clicked}
      />
      <Button
        className="w-full text-xl uppercase primary-button"
        onClick={handleSubmit}
        disabled={!answer || clicked}
      >
        {t('buttons.next')}
      </Button>
    </div>
  )
}

export default AnswerDropdown;
